export default {
  data: function () {
    return {
      isPriorMay23: false,
      isMay23: false,
      isPostMay23: false
    }
  },
  methods: {
    showVmfSlide: function () {
      return this.isPriorMay23 || this.isMay23 || this.isPostMay23
    },
    bannerBody: function () {
      if (this.isPriorMay23) {
        return 'Across the world, makers have responded with incredible solutions during the COVID-19 Pandemic. On May 23, 2020 Virtual Maker Faire will host a 24 hour event, featuring speakers, workshops and projects from the people behind this extraordinary civic response.'
      } else if (this.isMay23) {
        return 'Virtually Maker Faire is LIVE for 24 Hours! Makers around the World have responded to the COVID-19 Crisis with thoughtful ideas and solutions. Check out their projects and experience the event now!'
      } else {
        return 'Across the world, makers have responded with incredible solutions during the COVID-19 Pandemic. On May 23, 2020 Virtual Maker Faire hosted a 24 hour event, featuring speakers, workshops and projects from the people behind this extraordinary civic response.'
      }
    },
    secondButtonText: function () {
      return this.isPriorMay23 ? 'Learn More' : 'Go to Event'
    },
    showBothButtons: function () {
      return this.isMay23
    },
    showSecondButton: function () {
      return this.isPriorMay23 || this.isMay23
    },
    getDate: function () {
      const d = new Date()
      const year = d.getFullYear()
      const month = d.getMonth() + 1
      const day = d.getDate()
      if (month === 5 && year === 2020) {
        if (day < 23) {
          this.isPriorMay23 = true
          this.isMay23 = false
          this.isPostMay23 = false
        } else if (day === 23) {
          this.isPriorMay23 = false
          this.isMay23 = true
          this.isPostMay23 = false
        } else if (day > 23 && day <= 30) {
          this.isPriorMay23 = false
          this.isMay23 = false
          this.isPostMay23 = true
        } else {
          this.isPriorMay23 = false
          this.isMay23 = false
          this.isPostMay23 = false
        }
      }
    },
    goToVmfProjects: function () {
      this.$router.push('/viewAll/?category=virtual-maker-faire')
    }
  }
}
